import React, { useContext, useEffect } from "react";
import { Menu, type MenuProps, theme, Layout } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { ShopOutlined, UserOutlined, AppstoreAddOutlined, DashboardOutlined, ApartmentOutlined } from '@ant-design/icons';
import { AuthContext } from "../../../config/AuthContext";
import MetadataColors from "../../../styles/MetadataColors";

const { Sider } = Layout;

interface Props {
    currentVal: number,
    setPantalla: (value: number) => void;
}

const AppSider = (props: Props) => {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    useEffect(() => {
        document.title = 'Web Metadata';
    }, []);

    const menuItems = [
        {
            key: '0',
            icon: <DashboardOutlined />,
            label: 'Dashboard',
            path: '/metadata'
        },
        {
            key: '1',
            icon: <ShopOutlined />,
            label: 'Empresas',
            path: '/metadata/empresas'
        },
        {
            key: '2',
            icon: <UserOutlined />,
            label: 'Alumnos',
            path: '/metadata/alumnos' // Keeping 'alumnes' in URL consistent with others might be better, but user asked for 'Alumnos' screen. Let's use 'alumnos' for consistency with previous step.
        },
        {
            key: '3',
            icon: <ApartmentOutlined />,
            label: 'Cursos',
            path: '/metadata/cursos'
        },
        {
            key: '4',
            icon: <AppstoreAddOutlined />,
            label: 'Asignaciones',
            path: '/metadata/asignaciones'
        }
    ];

    const items: MenuProps['items'] = menuItems.map(item => ({
        key: item.key,
        icon: item.icon,
        label: item.label,
        onClick: () => navigate(item.path),
        style: location.pathname === item.path ? {
            backgroundColor: MetadataColors.colors.color5,
            color: MetadataColors.colors.color1,
            fontWeight: 'bold'
        } : {}
    }));

    // Determine active key based on path
    const activeItem = menuItems.find(item => item.path === location.pathname);
    const selectedKeys = activeItem ? [activeItem.key] : ['0'];

    return (
        <Sider style={{ background: colorBgContainer }} width={200}>
            <Menu
                mode="inline"
                selectedKeys={selectedKeys}
                style={{ height: '100%', borderRight: 0 }}
                items={items}
            />
        </Sider>
    );
}

export default AppSider;
